/**
 * @param {Array} array
 * @param {*} value
 */
export function toggleArrayItem(array, value) {
    const index = array.indexOf(value);

    if (index === -1) {
        array.push(value);
    } else {
        array.splice(index, 1);
    }
}
